










import { Component, Vue } from 'vue-property-decorator';
import { TokenUser } from '@/TokenUser'
import * as utils from '@/utils';
import * as utils_auth from '@/utils_auth';
import * as utils_tracker from '@/utils_tracker';
import ModalWrapperComponent from '@/components/ModalWrapperComponent.vue';             // @ is an alias to /src
import { useAuth } from '@/oauth'; // Adjust path if needed


@Component({
  name: 'Home',
  components: { ModalWrapperComponent }
})
export default class Home extends Vue {
  // prop reactive member variables publically available to the html template

  // public reactive member variables available to the html template

  public get loading(): boolean { return this.$store.state.loading }
  public get isAuthenticated(): boolean { return this.$store.getters.isAuthenticated }

  // public functions available to the html template

  // private, non-reactive member variables

  // private functions not available directly to HTML template
  private async mounted() {
    if (this.$store.state.devmode) console.log(`${this.$options.name} mounted()`)

    utils_tracker.page(this.$options.name)

    if (this.$route.params.title && this.$route.params.msg) utils.toast(this, this.$route.params.title, this.$route.params.msg)

    if (new Date() < new Date('03-26-2021')) utils.showTopAlert('warning', 'Announcement: We made a change to the FMV algorithm today that provides better estimates for low serial # moments.', null)
    if (new Date() < new Date('08-15-2021')) utils.showTopAlert('success', "Good news: We've lowered the collector score requirements for participating in LiveToken Auctions. You now need 1000 CS to post and 250 CS to bid.", null)

    await Vue.nextTick(); // Wait for DOM update cycle

    const auth = useAuth(this); // Access $auth *after* nextTick if possible, or just use this.$auth

    // while (auth.loading) {
    //   console.log('Homepage waiting for auth loading...');
    //   await new Promise(resolve => setTimeout(resolve, 50)); // Wait a bit
    // }

    console.log('Auth loading finished on homepage.');


    this.$nextTick(async () => {
      console.log(`this.$auth stuff:`)
      console.log(this.$auth.isAuthenticated)
      console.log(this.$auth.user)
      console.log(this.$auth.token)
    })


    // home page defaults to accounts
    try { await this.$router.push({ name: 'myaccount'}) } catch (Error) {}
  }

}

